// "Filters" panels (agents, skills, usage, automations...) per app. The three assistant apps built
// from this fork (NEXT_PUBLIC_MARQUE set to pirouette, boosts or electron) hide every one of them
// since 16/10 (Louka): their facets (editors, tags, hidden agents or skills...) exposed metadata
// members and admins must not see. Without a brand, or with any other brand, the accounting
// product keeps them.
const MARQUES_ASSISTANT: ReadonlySet<string> = new Set([
  "pirouette",
  "boosts",
  "electron",
]);

/** Whether the SPA brand is one of the three assistant apps (pirouette, boosts, electron). */
export function estMarqueAssistant(
  marque: string | undefined = process.env.NEXT_PUBLIC_MARQUE
): boolean {
  return typeof marque === "string" && MARQUES_ASSISTANT.has(marque);
}

/** Whether "Filters" panels are offered for the SPA brand. */
export function filtresProposes(
  marque: string | undefined = process.env.NEXT_PUBLIC_MARQUE
): boolean {
  return !estMarqueAssistant(marque);
}
